/* eslint-disable no-unused-vars*/
import React from 'react';
import { ErrorRobotContainer } from './error.styles';

export const ErrorPage404 = () => {
   return (
      <>
         <ErrorRobotContainer className="container_robot">
            <div className="message">
              คุณไม่มีสิทธิ์เข้าถึง
            </div>
            <div className="message2">คุณพยายามเข้าถึงหน้าที่คุณไม่ได้รับอนุญาต</div>
            <div
               style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignContent: 'flex-end',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
               }}
            >
               <div className="neon">403</div>
               <div className="door-frame">
                  <div className="door">
                     <div className="rectangle">
                     </div>
                     <div className="handle">
                     </div>
                     <div className="window">
                        <div className="eye">
                        </div>
                        <div className="eye eye2">
                        </div>
                        <div className="leaf">
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </ErrorRobotContainer>
      </>
   );
};
